import { z } from 'zod';

export const MAX_TEXT_FIELD_LENGTH = 300;
export const MAX_DESCRIPTION_LENGTH = MAX_TEXT_FIELD_LENGTH * 10;

/**
 * Validates that a URL starts with http:// or https://
 */
function isValidHttpUrl(value: string): boolean {
  try {
    const url = new URL(value);
    return ['http:', 'https:'].includes(url.protocol);
  } catch {
    return false;
  }
}

/**
 * Form validators for the account verification form.
 * Used with useForm's validators prop.
 */
export const accountVerificationFormValidators = {
  onChange: z.object({
    name: z.string().max(MAX_TEXT_FIELD_LENGTH, `Business name must be at most ${MAX_TEXT_FIELD_LENGTH} characters`),
    websiteUrl: z
      .string()
      .min(1, "Website can't be blank")
      .refine(isValidHttpUrl, { message: 'Please enter a valid URL starting with https:// or http://' }),
    industry: z.string().max(MAX_TEXT_FIELD_LENGTH, `Industry must be at most ${MAX_TEXT_FIELD_LENGTH} characters`),
    customIndustry: z
      .string()
      .max(MAX_TEXT_FIELD_LENGTH, `Industry must be at most ${MAX_TEXT_FIELD_LENGTH} characters`),
    longDescription: z
      .string()
      .max(MAX_DESCRIPTION_LENGTH, `Business description must be at most ${MAX_DESCRIPTION_LENGTH} characters`),
    privacyPolicyUrl: z.union([
      z.literal(''),
      z.string().url('Please enter a valid URL (e.g., https://example.com/privacy)'),
    ]),
    termsOfServiceUrl: z.union([
      z.literal(''),
      z.string().url('Please enter a valid URL (e.g., https://example.com/terms-of-service)'),
    ]),
  }),
};
